import { getMixpanelReady, getVariantValue } from '@thoughtspot/metrics';
import { useEffect, useState } from 'react';
import { getFallBackValue, getUrlFlagValue } from './experiments.config';
export function useABTesting(experimentationKey) {
    const [variant, setVariant] = useState(null);
    const [loading, setLoading] = useState(true);
    const urlFlagValue = getUrlFlagValue(experimentationKey);
    const fallbackValue = getFallBackValue(experimentationKey);
    useEffect(() => {
        if (urlFlagValue) {
            setVariant(urlFlagValue);
            setLoading(false);
            return undefined;
        }
        let isMounted = true;
        async function initializeVariant() {
            await getMixpanelReady();
            if (!isMounted)
                return;
            try {
                const value = await getVariantValue(experimentationKey, fallbackValue);
                if (isMounted) {
                    setVariant(value);
                    setLoading(false);
                }
            }
            catch {
                if (isMounted) {
                    setVariant(fallbackValue);
                    setLoading(false);
                }
            }
        }
        initializeVariant();
        return () => {
            isMounted = false;
        };
    }, [experimentationKey, fallbackValue, urlFlagValue]);
    return { variant, loading };
}
//# sourceMappingURL=useABTesting.js.map